export default __webpack_public_path__ + "static/media/play.f5afd3eb.svg";